










import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import moment from 'moment'
import { isValidMonthDayAndYear } from '@/utils/dateHelper'
import { Debounce } from 'vue-debounce-decorator'
const Datepicker = require('vuejs-datepicker').default

@Component({
  props: {
    dateTo: {
      type: Date
    },
    dateFrom: {
      type: Date
    },
    value: {
      type: [String, Date]
    },
    validation: {
      type: String
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    isAutoPay: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Icon,
    Datepicker
  }
})
export default class DateInput extends Vue {
  disabledDates: { from?: Date, to?: Date } = {}
  error: boolean = false
  nestedDateInput: Vue | undefined

  @Debounce(200)
  emitInput (value: Date | null) {
    if (!value) {
      this.emitInputAndError(value, this.$props.validation === 'required')
      return
    }
    let validTypedDate: boolean = true
    if (!this.nestedDateInput) {
      this.nestedDateInput = this.$refs.datepicker && (this.$refs.datepicker as Vue).$children
        .find(child => child.$vnode.tag && child.$vnode.tag.includes('date-input'))
    }
    const typedDate = this.nestedDateInput && (this.nestedDateInput as any).typedDate as string
    if (typedDate) {
      const splitTypedDate = typedDate.split('/')
      validTypedDate = isValidMonthDayAndYear(
        Number(splitTypedDate[0]),
        Number(splitTypedDate[1]),
        Number(splitTypedDate[2])
      )
      value = moment(typedDate, 'MM/DD/yyyy').toDate()
    }
    const error = !this.isDateWithinBounds(value) || !validTypedDate
    this.emitInputAndError(value, error)
  }

  emitInputAndError (value: Date | null, error: boolean) {
    this.error = error
    this.$emit('error', this.error)
    if (error) {
      value = this.$props.isAutoPay
        ? moment().add(1, 'day').toDate()
        : moment().toDate()
    }
    this.$emit('input', value)
  }

  isDateWithinBounds (value: Date | null) {
    const validDate = moment(value || moment()).toDate()
    const from = moment(this.disabledDates.from || moment()).toDate()
    const to = moment(this.disabledDates.to || moment()).toDate()
    return !(validDate < from) || !(validDate > to)
  }

  beforeMount () {
    if (this.$props.dateTo) {
      this.disabledDates.from = this.$props.dateTo
    }
    if (this.$props.dateFrom) {
      this.disabledDates.to = this.$props.dateFrom
    }
  }

  beforeDestroy () {
    window.removeEventListener('scroll', this.doAppendToBody)
  }

  clean () {
    (this.$refs.datepicker as any).clearDate()
  }

  doAppendToBody () {
    this.$nextTick(() => {
      const $input = this.$el.querySelector('input')
      const $calendar = this.$el.querySelector('.vdp-datepicker.zunta-datepicker  .vdp-datepicker__calendar')
      if (!$calendar || !$input) {
        return
      }
      const input = $input.getBoundingClientRect()
      // @ts-ignore
      $calendar.style.position = 'fixed'
      // @ts-ignore
      $calendar.style.top = `${input.top + input.height + 4}px`
      // @ts-ignore
      $calendar.style.left = `${input.left}px`
    })
  }

  addListeners () {
    if (!this.$props.appendToBody) {
      return
    }
    this.doAppendToBody()
    window.addEventListener('scroll', this.doAppendToBody)
  }

  removeListeners () {
    window.removeEventListener('scroll', this.doAppendToBody)
  }
}
